const envBase = process.env.REACT_APP_API_BASE_URL;
const apiFallbackBase = process.env.NODE_ENV === "development"
  ? "http://localhost:5002"
  : "https://backend.himconerp.com";

export const API_BASE_URL = envBase || apiFallbackBase;
